/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

'use client';

import { Chip as MuiChip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { memo, useMemo } from 'react';

import { type ChipProps } from './chip.interface';

const Chip = styled(
  ({ endIcon, label, onDelete, selected, startIcon, ...other }: ChipProps) => {
    const additionalProps = useMemo(
      () => ({
        'aria-label': typeof label === 'string' ? label : undefined,
        'aria-pressed': selected != null ? selected : undefined,
      }),
      [label, selected]
    );

    // Force showing end icon if onDelete is not provided - User didn't intend for delete action
    const forceEndIcon = endIcon != null && onDelete == null;

    return (
      <MuiChip
        deleteIcon={endIcon}
        icon={startIcon}
        label={label}
        selected={selected}
        onDelete={forceEndIcon ? () => {} : (onDelete ?? undefined)}
        {...additionalProps}
        {...other}
      />
    );
  },
  {
    name: 'Chip',
    slot: 'root',
  }
)<ChipProps>();

export default memo(Chip);
